module.exports = __webpack_public_path__ + "media/images/thumbs/anatomyphysiology/ai400-cf7e07e49f6be3e0b849ffea98814ca6.jpg";